import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'

import { Avatar } from '../utils/avatar'
import { initTooltips } from '../utils/tooltips'

function UsersOnline({ url }) {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    let timer

    async function load() {
      setLoading(true)
      setError(null)
      try {
        const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        if (!cancelled) setUsers(payload.users || [])
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    timer = setInterval(load, 5 * 60 * 1000)

    return () => {
      cancelled = true
      if (timer) clearInterval(timer)
    }
  }, [url])

  useEffect(() => {
    initTooltips(document)
  }, [users])

  function renderContent() {
    if (loading) return <div className="list-group-item text-body-secondary">Loading users…</div>
    if (error) return <div className="list-group-item text-danger">{error}</div>
    if (!users.length) return <div className="list-group-item text-body-secondary">No one online right now.</div>

    return users.map((user) => (
      <div key={user.id} className="list-group-item d-flex align-items-center gap-3">
        <Avatar user={user} size="sm" online />
        <div>
          <div className="fw-semibold">{user.name}</div>
        </div>
      </div>
    ))
  }

  return (
    <div className="card h-100">
      <div className="card-header d-flex justify-content-between align-items-center">
        <div>
          <div className="text-uppercase text-body-secondary fw-semibold small">
            Users online
          </div>
          <div className="fw-semibold">Last 15 minutes</div>
        </div>
        {loading ? (
          <div
            className="spinner-border spinner-border-sm text-primary"
            role="status">
            <span className="visually-hidden">Loading…</span>
          </div>
        ) : null}
      </div>
      <div className="card-body">
        <div className="list-group list-group-flush">{renderContent()}</div>
      </div>
    </div>
  );
}

export function mountOnlineUsersWidget(el) {
  const url = el?.dataset?.onlineUrl
  if (!url) return
  const root = createRoot(el)
  root.render(<UsersOnline url={url} />)
}
